import {
  addCarouselFunctionality, getBranchedQuestionnairePayload,
  getQuickApplyPayload,
  LOAD_RECOMMENDED_JOBS_EVENT,
  UPDATE_CAROUSEL_EVENT,
  UPDATE_LAST_PAGE_EVENT
} from '../../../../lib/helpers/common';
import {
  branchedQuestionsFetch,
  getRecommendedJobs,
  quickJobApplyJobDetails
} from "../../../../lib/helpers/jobHelpers";

export default () => {
  apos.util.widgetPlayers.recommendedJobs = {
    selector: '.recommended-jobs-widget',
    player: async function (recommendedJobs) {
      if (!recommendedJobs) {
        return;
      }

      const jobListContainer = recommendedJobs.querySelector('.job-list');

      addCarouselFunctionality(recommendedJobs);

      function updateCarousel() {
        recommendedJobs.dispatchEvent(new Event(UPDATE_CAROUSEL_EVENT));
        recommendedJobs.dispatchEvent(new Event(UPDATE_LAST_PAGE_EVENT));
      }

      function updateLoadingCards(jobs) {
        if (jobs.length) {
          const loadingTemplate = jobListContainer.querySelector('.job-card.loading');
          if (loadingTemplate) {
            jobListContainer.innerHTML = loadingTemplate?.outerHTML.repeat(jobs.length);
          }

          updateCarousel();
        }
      }

      async function loadRecommendedJobs() {
        const recommendedJobHtml = await renderRecommendedJobsList();

        if (recommendedJobHtml == null) {
          return;
        }

        jobListContainer.innerHTML = recommendedJobHtml;

        const oneClickApplyButtons = recommendedJobs.querySelectorAll('.one-click-apply-button');
        if (oneClickApplyButtons.length) {
          oneClickApplyButtons.forEach(oneClickApplyButton => {
            oneClickApplyButton.addEventListener('click', oneQuickApply);
          });
        }

        const appliedLabel = recommendedJobs.querySelector('.one-click-apply-applied-label');
        const appliedLabelContainer = recommendedJobs.querySelectorAll('.one-click-apply-applied-container');

        if (appliedLabel && appliedLabelContainer && appliedLabelContainer.length) {
          appliedLabelContainer.forEach(container => {
            container.innerHTML = appliedLabel.innerHTML;
          });
        }

        updateCarousel();
      }

      async function updateJobListContent() {
        const jobs = getRecommendedJobs();

        if (jobs.length) {
          recommendedJobs.style.display = 'block';
          updateLoadingCards(jobs);
          await loadRecommendedJobs();
        } else {
          recommendedJobs.style.display = 'none';
        }
      }

      // if the widget is visible try to load the cards
      if (recommendedJobs.checkVisibility() && recommendedJobs.dataset.preview === 'false') {
        await loadRecommendedJobs();
      }

      // add event to use it in other widgets
      recommendedJobs.addEventListener(LOAD_RECOMMENDED_JOBS_EVENT, updateJobListContent);

      async function oneQuickApply(event) {
        const button = event.target;
        const jobPostingId = button.dataset.jobId;
        const jobTitle = button.dataset.jobTitle;
        const questionnaireId = button.dataset.questionnaireId;
        const isBranchedQuestionnaire = button.dataset.isBranchedQuestionnaire === 'true';
        const companyCode = button.dataset.companyCode;
        const resumeUploadRequired = button.dataset.resumeUploadRequired;

        setTimeout(() => {
          button.classList.add('d-none');
          recommendedJobs.querySelector(`.one-click-apply-applied-container[data-job-id="${jobPostingId}"]`)
            .classList
            .remove('d-none');
        }, 200);

        await quickApply(jobPostingId, companyCode, resumeUploadRequired, jobTitle, questionnaireId, isBranchedQuestionnaire);
      }

      async function quickApply(jobPostingId, companyCode, resumeUploadRequired, jobTitle, questionnaireId, isBranchedQuestionnaire) {
        const quickApplyDataPayload = await getQuickApplyPayload();

        if (Object.keys(quickApplyDataPayload).length === 0) {
          return;
        }

        const serializedFormData = quickApplyDataPayload.serializedFormData;
        const questionnaireInfo = JSON.parse(serializedFormData.questionnaireInfo || '{}');
        const isSameQuestionnaire = String(questionnaireInfo.questionTemplateId) === questionnaireId;

        // if branched, validate the data and make the subsequences request
        if (isSameQuestionnaire && isBranchedQuestionnaire && serializedFormData.isBranched === 'true') {
          // user should be already registered at this point, so it should only answer the questions for
          // the current job
          const branchedQuestionnairePayload = getBranchedQuestionnairePayload();

          for (const question of branchedQuestionnairePayload.questions) {
            // update metadata of question to match with current job
            if (question?.questionnaireInfo) {
              question.questionnaireInfo.jobPostingId = jobPostingId;
            } else {
              console.log('Invalid questionnaire answer format: ', question);
              return;
            }

            try {
              await branchedQuestionsFetch(question, false);
            } catch (e) {
              console.log(e);
              return;
            }
          }
        }

        const userData = JSON.parse(serializedFormData.user || '{}');
        const payload = {
          companyCode,
          isBranched: String(isBranchedQuestionnaire),
          jobPostingId,
          resume: `{"resumename":"","resumeLink":"","jobpostingid":${jobPostingId}}`,
          resumeUploadRequired,
          user: serializedFormData.user,
          userAgent: 'WL-CMS',
          userAgreement: userData.userAgreement
        };

        // add questionnaireInfo if exists and we have the answers from last questionnaire
        if (isSameQuestionnaire) {
          questionnaireInfo.jobPostingId = jobPostingId;
          payload.questionnaireInfo = JSON.stringify(questionnaireInfo);
        }

        const formData = new FormData();
        Object.keys(payload).forEach(key => {
          formData.append(key, payload[key]);
        });

        if (serializedFormData.resumefile) {
          formData.append('resumefile', serializedFormData.resumefile.blob, serializedFormData.resumefile.filename)
        }

        const response = await quickJobApplyJobDetails(formData, resumeUploadRequired);
        // Track Click on Submit Quick Apply Button
        logWLAnalyticsEvent(`Job Apply Submitted`, {
          userId: response.userId,
          jobPostingId,
          jobTitle,
          quickApply: true,
          resumeAttached: serializedFormData.resumefile != undefined,
          loggedIn: false,
        });
      }

      async function renderRecommendedJobsList() {
        const fitScoreColor = recommendedJobs.dataset.fitScoreColor;
        const oneClickApplyConfig = JSON.parse(recommendedJobs.dataset.oneClickApplyConfig || '{}');

        try {
          return await apos.http.post('/api/v1/recommended-jobs-widget/render-recommended-jobs', {
            prefix: false,
            body: {
              fitScoreColor,
              oneClickApplyConfig
            }
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
    }
  };
};
